import React from 'react';
import {
	ConfluenceClientsProvider as ConfluenceSearchClientProviderDI,
	JiraSearchClientProvider as JiraSearchClientProviderDI,
} from '@atlassian/product-search-dialog';
import { SEARCH_ENDPOINT } from './constants.tsx';
import type { ClientProviderProps } from './types.tsx';

export const ClientProvider = ({
	// @ts-expect-error - TS2322 - Type 'FunctionComponent<SearchClientConfig>' is not assignable to type 'ComponentType<JiraClientProviderProps>'.
	JiraSearchClientProvider = JiraSearchClientProviderDI,
	ConfluenceClientsProvider = ConfluenceSearchClientProviderDI,
	children,
	cloudId,
	isAnonymous,
	atlassianAccountId,
}: ClientProviderProps) => {
	const clientProviderConfig = {
		cloudId,
		isUserAnonymous: isAnonymous,
		aggregatorUrl: `/${SEARCH_ENDPOINT}`,

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		baseUrl: `${window.location.protocol}//${window.location.hostname}`,
		collaborationGraphUrl: '/gateway/api/collaboration',
		accountId: atlassianAccountId,
	};

	return (
		<JiraSearchClientProvider {...clientProviderConfig}>
			<ConfluenceClientsProvider
				config={{
					...clientProviderConfig,
					// seems to be a valid usage of baseUrl, it is a full url
					baseUrl: `${clientProviderConfig.baseUrl}/wiki`,
				}}
			>
				{children(clientProviderConfig)}
			</ConfluenceClientsProvider>
		</JiraSearchClientProvider>
	);
};
